import React from 'react';

export default function Admin() {
  return (
    <div className="h-full flex flex-col bg-white">
      <header className="px-8 py-6 border-b border-slate-200">
        <h1 className="text-2xl font-bold text-slate-800">Admin Dashboard</h1>
        <p className="text-slate-500 mt-1">Manage users and credit balances</p>
      </header>
      <div className="p-8">
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="px-6 py-4 font-medium text-slate-600 text-sm">User</th>
                <th className="px-6 py-4 font-medium text-slate-600 text-sm">Role</th>
                <th className="px-6 py-4 font-medium text-slate-600 text-sm">Credits</th>
                <th className="px-6 py-4 font-medium text-slate-600 text-sm">Status</th>
                <th className="px-6 py-4 font-medium text-slate-600 text-sm text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              <tr className="hover:bg-slate-50">
                <td className="px-6 py-4">
                  <div className="font-medium text-slate-800">user@example.com</div>
                  <div className="text-sm text-slate-500">Joined Oct 2, 2026</div>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">User</span>
                </td>
                <td className="px-6 py-4 text-slate-800 font-medium">20</td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Active</span>
                </td>
                <td className="px-6 py-4 text-right">
                  <button className="text-sm text-blue-600 font-medium hover:text-blue-700 mr-4">Add Credits</button>
                  <button className="text-sm text-red-600 font-medium hover:text-red-700">Block</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
